/**
 * Include your custom JavaScript here.
 */

/* ============================================================
   PANDORA — Envío gratis: mostrar solo si la región es Santiago
   ============================================================ */
(function () {
  var STORAGE_KEY = 'pandora_shipping_province';

  function isSantiago(val) {
    return typeof val === 'string' && val.toLowerCase().indexOf('santiago') !== -1;
  }

  function applyVisibility() {
    var province = '';
    try { province = localStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
    var show = isSantiago(province);
    document.querySelectorAll('.js-free-shipping-remaining').forEach(function (el) {
      el.style.display = show ? '' : 'none';
    });
  }

  /* Escuchar cambios en el selector de región/provincia del estimador */
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target) return;
    if (
      target.id === 'shipping-estimator-province' ||
      (target.name === 'province' && target.closest('.shipping-estimator'))
    ) {
      try { localStorage.setItem(STORAGE_KEY, target.value); } catch (e) {}
      applyVisibility();
    }
  });

  /* Aplicar al cargar la página y después de que el mini-cart se re-renderice */
  function init() {
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-aplicar cuando el mini-cart o el carrito se actualicen */
  document.addEventListener('cart:rerendered', applyVisibility);
  document.addEventListener('theme:cart:updated', applyVisibility);
})();

/* ============================================================
   PANDORA — Opciones de producto verticales con selección única
   ============================================================ */
(function () {
  var obs;

  function normalize(v){
    return (v || '').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function pandoraInit() {
    /* Si ya existe lista proxy, no crear otra */
    if (document.querySelector('.pandora-options-list')) return;

    var all = Array.from(document.querySelectorAll(
      'input[type="checkbox"][name*="properties["]'
    ));
    if (!all.length) {
      var seen = new Set();
      ['form[action="/cart/add"] input[type="checkbox"]',
       '#shopify-section-product-template input[type="checkbox"]',
       '.product-form input[type="checkbox"]'
      ].forEach(function(sel){
        try{ document.querySelectorAll(sel).forEach(function(el){
          if(!seen.has(el)){ seen.add(el); all.push(el); }
        }); }catch(e){}
      });
    }
    if (!all.length) return;

    var groups = {};
    all.forEach(function (cb) {
      var n = cb.getAttribute('name') || '_group';
      if (!groups[n]) groups[n] = [];
      groups[n].push(cb);
    });

    var createdAny = false;

    Object.keys(groups).forEach(function (gName) {
      var fullGroup = groups[gName];

      /* Deduplicar por value normalizado */
      var seenVals = {};
      var unique = fullGroup.filter(function (cb) {
        var v = normalize(cb.value) || cb.id || '_';
        if (seenVals[v]) return false;
        seenVals[v] = true;
        return true;
      });

      var container = fullGroup[0].parentElement;
      while (container && container !== document.body) {
        if (fullGroup.every(function (cb) { return container.contains(cb); })) break;
        container = container.parentElement;
      }
      if (!container || container === document.body) return;

      fullGroup.forEach(function (cb) { cb.checked = false; });
      container.style.cssText += ';position:absolute!important;opacity:0!important;height:0!important;overflow:hidden!important;pointer-events:none!important;margin:0!important;padding:0!important';

      var list = document.createElement('div');
      list.className = 'pandora-options-list';
      var rows = [];

      unique.forEach(function (cb, idx) {
        var row = document.createElement('label');
        row.className = 'pandora-option-row';
        var dot = document.createElement('span'); dot.className = 'pandora-radio-dot';
        var labelEl = cb.id ? document.querySelector('label[for="' + cb.id + '"]') : null;
        var labelTxt = labelEl ? labelEl.textContent.trim() : '';
        var valueTxt = (cb.value && cb.value !== 'on') ? cb.value.trim() : '';
        var txt = document.createElement('span'); txt.className = 'pandora-option-text';
        txt.textContent = labelTxt || valueTxt || ('Opción ' + (idx + 1));
        row.appendChild(dot); row.appendChild(txt);
        list.appendChild(row); rows.push(row);

        row.addEventListener('click', function (e) {
          e.preventDefault();
          /* Desmarcar todos y notificar a la app con evento change */
          fullGroup.forEach(function (o) {
            o.checked = false;
            o.dispatchEvent(new Event('change', { bubbles: true }));
          });
          rows.forEach(function (r) { r.classList.remove('is-selected'); });
          /* Marcar los que coinciden y notificar a la app */
          fullGroup.forEach(function (o) {
            if (normalize(o.value) === normalize(cb.value)) {
              o.checked = true;
              o.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          row.classList.add('is-selected');
        });
      });

      container.parentNode.insertBefore(list, container);
      createdAny = true;
    });

    if (createdAny && obs) { obs.disconnect(); obs = null; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pandoraInit);
  } else {
    pandoraInit();
  }
  setTimeout(pandoraInit, 500);
  setTimeout(pandoraInit, 1500);

  obs = new MutationObserver(pandoraInit);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { if(obs){ obs.disconnect(); obs = null; } }, 15000);
})();